class CountUp extends HTMLElement {
  #target = 0;
  #prefix = '';
  #suffix = '';
  #duration = 1000;
  #observer = null;
  #animated = false;
  #resizeHandler = null;

  connectedCallback() {
    this.#target = parseFloat(this.dataset.target) || 0;
    this.#prefix = this.dataset.prefix || '';
    this.#suffix = this.dataset.suffix || '';

    if (this.dataset.animate === 'false' || isNaN(this.#target)) {
      this.#renderStatic();
      return;
    }

    this.#measureWidth();
    this.#renderValue(0);
    this.#observe();

    this.#resizeHandler = () => this.#recalcWidth();
    window.addEventListener('resize', this.#resizeHandler);
  }

  disconnectedCallback() {
    this.#observer?.disconnect();
    if (this.#resizeHandler) {
      window.removeEventListener('resize', this.#resizeHandler);
    }
  }

  #measureWidth() {
    const current = this.textContent;
    this.textContent = `${this.#prefix}${this.dataset.target}${this.#suffix}`;
    this.style.minWidth = this.offsetWidth + 'px';
    this.textContent = current;
  }

  #recalcWidth() {
    this.style.minWidth = '';
    const current = this.textContent;
    this.textContent = `${this.#prefix}${this.dataset.target}${this.#suffix}`;
    this.style.minWidth = this.offsetWidth + 'px';
    this.textContent = current;
  }

  #observe() {
    this.#observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting && !this.#animated) {
            this.#animated = true;
            this.#animate();
            this.#observer.disconnect();
          }
        });
      },
      { threshold: 0.3 }
    );
    this.#observer.observe(this);
  }

  #animate() {
    const start = performance.now();
    const isInteger = Number.isInteger(this.#target);

    const step = (now) => {
      const elapsed = now - start;
      const progress = Math.min(elapsed / this.#duration, 1);
      const eased = 1 - Math.pow(1 - progress, 3);
      const current = eased * this.#target;

      this.#renderValue(isInteger ? Math.round(current) : parseFloat(current.toFixed(1)));

      if (progress < 1) {
        requestAnimationFrame(step);
      }
    };

    requestAnimationFrame(step);
  }

  #renderValue(value) {
    this.textContent = `${this.#prefix}${value}${this.#suffix}`;
  }

  #renderStatic() {
    this.textContent = `${this.#prefix}${this.dataset.target || ''}${this.#suffix}`;
  }
}

customElements.define('count-up', CountUp);
